export default __webpack_public_path__ + "static/media/icon-applepodcasts.6744ce5e.svg";